import React from "react";
import { GrClose } from "react-icons/gr";
import NextImage from "../NextImage";
import { validateImgSrc } from "@/utils/global";

const ImagePreview = ({ imageUrl, onClose }) => {
  return (
    <div
      className="fixed inset-0 flex items-center justify-center z-[9999]"
      onClick={() => onClose(false)}
    >
      <div className="fixed inset-0 bg-black opacity-50"></div>
      <div className="relative bg-white p-4 shadow-lg rounded-md">
        <button
          onClick={() => onClose(false)}
          className="absolute top-0 right-0 m-2 p-2 text-gray-500 hover:text-gray-800 transition ease-in-out duration-150"
        >
          <GrClose />
        </button>
        <NextImage
          width={1100}
          height={700}
          src={validateImgSrc(imageUrl)}
          alt="Preview"
          className="max-w-full max-h-full w-[80vw] h-[70vh] object-contain"
        />
      </div>
    </div>
  );
};

export default ImagePreview;
